// extracted by mini-css-extract-plugin
export var buttons = "request-trade-account-module--buttons--8262a";
export var container = "request-trade-account-module--container--5ffd1";
export var text = "request-trade-account-module--text--084a5";
export var title = "request-trade-account-module--title--11057";